module.exports = __webpack_public_path__ + "static/media/ios-dark-theme.8e9cb3df.png";